import React, { useCallback, useMemo, Ref, PropsWithChildren  } from 'react'
import { Slate, Editable, withReact,  useSlate  } from 'slate-react'
import {
  Editor,
  Transforms,
  Range,
  Point,
  Descendant,
  createEditor,
  Element as SlateElement,
  Node
} from 'slate';
import { withHistory } from 'slate-history'
import { cx, css } from '@emotion/css'
import { MdFormatBold, MdFormatItalic, MdStrikethroughS, MdFormatUnderlined, MdFormatQuote, MdFormatAlignLeft, MdFormatAlignCenter, MdFormatAlignRight, MdFormatListNumbered, MdFormatListBulleted,MdInsertLink,MdVideoLibrary,MdImage,MdAdd,MdKeyboardArrowRight, MdArrowForward} from 'react-icons/md'
import { BsTypeH1, BsTypeH2, BsTypeH3, BsCameraVideoFill } from 'react-icons/bs'
import { FaSuperscript,FaSubscript } from 'react-icons/fa'
import { AiFillEdit,AiOutlineTable, AiOutlineInsertRowBelow, AiOutlineInsertRowRight,AiOutlineDelete, AiFillTag, AiOutlineUpload, AiOutlineArrowsAlt, AiOutlineInsertRowAbove, AiOutlineInsertRowLeft,AiFillHtml5 } from 'react-icons/ai'
import { SiLatex } from 'react-icons/si'

const LIST_TYPES = ['numbered-list', 'bulleted-list']
const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify']

const VtxEditor = (props) => {
  const initialValue = props.initialValue;
  const renderElement = useCallback(props => <Element {...props} />, [])
  const renderLeaf = useCallback(props => <Leaf {...props} />, [])
  const editor = useMemo(
    () => withTables(withHistory(withReact(createEditor()))),
    []
  )
  // Define a serializing function that takes a value and returns a string.
const serialize = value => {
  return (
    value
      // Return the string content of each paragraph in the value's children.
      .map(n => Node.string(n))
      // Join them all with line breaks denoting paragraphs.
      .join('\n')
  )
}
  return (
    <Slate editor={editor} value={initialValue}    
        onChange={value => {
          const isAstChange = editor.operations.some(
            op => 'set_selection' !== op.type
          )
          if (isAstChange) {
            // Save the value to Local Storage.
            const content = JSON.stringify(value)
            //localStorage.setItem('content', content)
            props.onChange(content);
          }
        }}
    >
     <Toolbar>
        <MarkButton format="bold" icon="bold" />
        <MarkButton format="italic" icon="italic" />
        <MarkButton format="underline" icon="underline" />
        {/* <MarkButton format="code" icon="code" /> */}
        <BlockButton format="headingone" icon="headingOne" />
        <BlockButton format="heading-two" icon="headingTwo" />
        <BlockButton format="block-quote" icon="headingThree" />
        {/* <BlockButton format="numbered-list" icon="format_list_numbered" />
        <BlockButton format="bulleted-list" icon="format_list_bulleted" /> */}
        <BlockButton format="left" icon="alignLeft" />
        <BlockButton format="center" icon="alignCenter" />
        <BlockButton format="right" icon="alignRight" />
        {/* <BlockButton format="justify" icon="format_align_justify" /> */}
        <BlockButton format="table" icon="table" />
      </Toolbar>      
      <Editable renderElement={renderElement} renderLeaf={renderLeaf} />
    </Slate>
  )
}
const iconList={
  bold:<MdFormatBold size={20}/>,
  italic:<MdFormatItalic size={20}/>,
  strikethrough:<MdStrikethroughS size={20}/>,
  underline:<MdFormatUnderlined size={20}/>,
  headingOne:<BsTypeH1 size={20}/>,
  headingTwo:<BsTypeH2 size={20}/>,
  headingThree:<BsTypeH3 size={20}/>,

  blockquote:<MdFormatQuote size={20}/>,
  superscript:<FaSuperscript size={15}/>,
  subscript:<FaSubscript size={15}/>,
  alignLeft:<MdFormatAlignLeft size={20}/>,
  alignCenter:<MdFormatAlignCenter size={20}/>,
  alignRight:<MdFormatAlignRight size={20}/>,
  orderedList:<MdFormatListNumbered size={20}/>,
  unorderedList:<MdFormatListBulleted size={20}/>,
  link:<MdInsertLink size={20}/>,
  image:<MdImage size={20}/>,
  video:<MdVideoLibrary size={20}/>,
  add:<MdAdd size={20}/>,
  table:<AiOutlineTable size={20}/>,
  insertRowBelow:<AiOutlineInsertRowBelow size={25}/>,
  insertColumnRight:<AiOutlineInsertRowRight size={25}/>,
  insertColumnLeft:<AiOutlineInsertRowLeft size={25}/>,
  insertRowAbove:<AiOutlineInsertRowAbove size={25}/>,
  trashCan:<AiOutlineDelete size={25}/>,
  addId:<AiFillTag size={20}/>,
  upload:<AiOutlineUpload size = {20}/>,
  equation:<SiLatex size={20} />,
  resize:<AiOutlineArrowsAlt size={20}/>,
  videoPlayer:<BsCameraVideoFill size={20}/>,
  insertHtml:<AiFillHtml5 size={20}/>,
  arrowRight:<MdArrowForward size={35}/>,
  pen:<AiFillEdit size={20}/>
}

const Icon = (props)=>{
  const {icon} = props
  console.log(props);
  return(
    iconList[icon]
  )
}
const withTables = editor => {
  const { deleteBackward, deleteForward, insertBreak } = editor

  editor.deleteBackward = unit => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: n =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === 'table-cell',
      })

      if (cell) {
        const [, cellPath] = cell
        const start = Editor.start(editor, cellPath)

        if (Point.equals(selection.anchor, start)) {
          return
        }
      }
    }

    deleteBackward(unit)
  }

  editor.deleteForward = unit => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: n =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === 'table-cell',
      })

      if (cell) {
        const [, cellPath] = cell
        const end = Editor.end(editor, cellPath)

        if (Point.equals(selection.anchor, end)) {
          return
        }
      }
    }

    deleteForward(unit)
  }

  editor.insertBreak = () => {
    const { selection } = editor

    if (selection) {
      const [table] = Editor.nodes(editor, {
        match: n =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === 'table',
      })

      if (table) {
        return
      }
    }

    insertBreak()
  }

  return editor
}
const Element = ({ attributes, children, element }) => {
  switch (element.type) {
    case 'table':
      return (
        <table border="0" width={'100%'}>
          <tbody {...attributes}>{children}</tbody>
        </table>
      )
    case 'table-row':
      return <tr {...attributes}>{children}</tr>
    case 'table-cell':
      return <td {...attributes}>{children}</td>
    case 'list':
        return <li {...attributes}>{children}</li>
    case 'div':
      return <div id='docx' {...attributes}>{children}</div>
    case 'image':
      return <img width={'200px'} src='data:image/png;base64,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' />
    case 'paragraph':
        return <p style={{padding:'0', margin:'0'}} >{children}</p>
    default:
      return <p {...attributes}>{children}</p>
  }
}
const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>
  }
  if (leaf.h1) {
    children = <h1>{children}</h1>
  }

  return <span {...attributes}>{children}</span>
}
export const Button = React.forwardRef(
  (
    {
      className,
      active,
      reversed,
      ...props
    },
    ref
  ) => (
    <span
      {...props}
      ref={ref}
      className={cx(
        className,
        css`
          cursor: pointer;
          color: ${reversed
            ? active
              ? 'white'
              : '#aaa'
            : active
            ? 'black'
            : '#ccc'};
        `
      )}
    />
  )
)
const BlockButton = ({ format, icon }) => {
  const editor = useSlate()
  return (
    <Button
      active={isBlockActive(
        editor,
        format,
        TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
      )}
      onMouseDown={event => {
        event.preventDefault()
        toggleBlock(editor, format)
      }}
    >
      <Icon icon={icon}></Icon>
    </Button>
  )
}
const MarkButton = ({ format, icon }) => {
  const editor = useSlate()
  return (
    <Button
      active={isMarkActive(editor, format)}
      onMouseDown={event => {
        event.preventDefault()
        toggleMark(editor, format)
      }}
    >
      <Icon icon={icon}></Icon>
    </Button>
  )
}
const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format)

  if (isActive) {
    Editor.removeMark(editor, format)
  } else {
    Editor.addMark(editor, format, true)
  }
}
const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(
    editor,
    format,
    TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
  )
  const isList = LIST_TYPES.includes(format)

  Transforms.unwrapNodes(editor, {
    match: n =>
      !Editor.isEditor(n) &&
      SlateElement.isElement(n) &&
      LIST_TYPES.includes(n.type) &&
      !TEXT_ALIGN_TYPES.includes(format),
    split: true,
  })
  let newProperties;
  if (TEXT_ALIGN_TYPES.includes(format)) {
    newProperties = {
      align: isActive ? undefined : format,
    }
  } else {
    newProperties = {
      type: isActive ? 'paragraph' : isList ? 'list-item' : format,
    }
  }
  Transforms.setNodes<SlateElement>(editor, newProperties)

  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}
const isBlockActive = (editor, format, blockType = 'type') => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n[blockType] === format,
    })
  )

  return !!match
}
const isMarkActive = (editor, format) => {
  const marks = Editor.marks(editor)
  return marks ? marks[format] === true : false
}


export default VtxEditor

export const Toolbar = React.forwardRef(
  (
    { className, ...props },
    ref
  ) => (
    <Menu
      {...props}
      ref={ref}
      className={cx(
        className,
        css`
          position: relative;
          padding: 1px 18px 17px;
          margin: 0 -20px;
          border-bottom: 2px solid #eee;
          margin-bottom: 20px;
        `
      )}
    />
  )
)

export const Menu = React.forwardRef(
  (
    { className, ...props },
    ref
  ) => (
    <div
      {...props}
      ref={ref}
      className={cx(
        className,
        css`
          & > * {
            display: inline-block;
          }
          & > * + * {
            margin-left: 15px;
          }
        `
      )}
    />
  )
)
// export const Icon = React.forwardRef(
//   (props, ref) => (
//     <>
//       <span
//         {...props}
//         ref={ref}
//         className={cx(
//           'material-icons',
//           props.children,
//           css({
//             fontSize: '18px',
//             verticalAlign: 'text-bottom'

//           })
//         )}
//       />
//     </>
//   )
// )

